// extracted by mini-css-extract-plugin
module.exports = {"tagStoresList":"TagStoresList_tagStoresList__w56_R","tagStoresListItem":"TagStoresList_tagStoresListItem__MzC5y"};